import { onMounted, onUnmounted, ref, Ref } from 'vue';
import { infuse } from '../../../ioc-config';
import { Logger } from '../../../utils/logger.util';
import { loadScriptAsync, loadStyleAsync } from '../../../utils/script-loader.util';

// TS-Support
declare global {
  interface Window {
    DealerLocator: any;
  }
}

export const useDealerLocatorWidget = (dealerSelectorConfiguration: Ref<Record<string, any>>) => {
  const { dealerLocator } = infuse('config');
  const widgetInstance = ref();
  const isInitialized = ref(false);

  const initializeWidget = async (): Promise<void> => {
    const { DealerLocator } = window;

    widgetInstance.value = new DealerLocator(dealerSelectorConfiguration.value);
    await widgetInstance.value.init();
    isInitialized.value = true;
  };

  const destroyWidget = (): Promise<void> => {
    return widgetInstance.value?.destroy();
  };

  // Component needs to wait for Dealer Locator styles and scripts to load before initializing
  onMounted(() => {
    Promise.all([loadScriptAsync(dealerLocator.script), loadStyleAsync(dealerLocator.styles)])
      .then(() => initializeWidget())
      .catch((err) => {
        Logger.warn('DealerLocatorSelector::created() -> initialisation failed', err);
      });
  });

  onUnmounted(() => {
    try {
      destroyWidget();
    } catch (err) {
      Logger.error('DealerLocatorSelector::destroyed() -> Failed to destroy DL instance');
    }
  });

  return {
    initialize: initializeWidget,
    isInitialized,
    instance: widgetInstance,
    destroy: destroyWidget,
  };
};
